import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723efa98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Bill To"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-info-circle info-icon",
    id: "billTo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The option selected will be passed onto the Energy Supplier of the Property.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Any bills for this account will be sent to the selected address.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If there is an issue with your Agency Billing address, please let us know by emailing support@propertybutton.ie", -1))

import { PropType, computed, onMounted, ref, watch } from "vue";
import BillToCard from "./bill-to-card.vue";
import { useAgencyAccountStore } from "@/stores/utility-switching/AgencyAccountStore";
import { AgencyAccount } from "@/types/switches/AgencyAccount";
import { SwitchBillTo } from "@/enums/utility-switching/SwitchBillTo";
import { DxTooltip } from "devextreme-vue/tooltip";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { formatAddress } from "@/utils/address/AddressFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'bill-to-select',
  props: {
  /**
   * The model value representing the current state for switching billing options.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number as PropType<SwitchBillTo>,
    required: true,
  },

  /**
   * The personal information of the landlord.
   * @type {LandlordPersonalInfo}
   * @required
   */
  landlord: {
    type: Object as PropType<LandlordPersonalInfo>,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const billTo = computed({
  get: () => props.modelValue,
  set: (value: SwitchBillTo) => emit("update:modelValue", value),
});

const landlordChecked = ref(false);
const agencyChecked = ref(false);

const agencyAccountStore = useAgencyAccountStore();
const account = ref<AgencyAccount>();
const loading = ref(false);

onMounted(async () => {
  account.value = await agencyAccountStore.getAccount();
});

watch(
  () => props.modelValue,
  () => {
    loading.value = true;

    switch (props.modelValue) {
      case SwitchBillTo.Landlord:
        landlordChecked.value = true;
        agencyChecked.value = false;
        break;
      case SwitchBillTo.LandlordCOAgency:
        landlordChecked.value = false;
        agencyChecked.value = true;
        break;
    }

    loading.value = false;
  },
  { immediate: true },
);

watch(
  () => landlordChecked.value,
  () => {
    if (loading.value) {
      return;
    }

    if (landlordChecked.value) {
      billTo.value = SwitchBillTo.Landlord;
    } else {
      /* The options need to be treated as a radio button. 
        If we untick the option, it needs to tick the other option */
      agencyChecked.value = true;
    }
  },
);

watch(
  () => agencyChecked.value,
  () => {
    if (loading.value) {
      return;
    }

    if (agencyChecked.value) {
      billTo.value = SwitchBillTo.LandlordCOAgency;
    } else {
      /* The options need to be treated as a radio button. 
        If we untick the option, it needs to tick the other option */
      landlordChecked.value = true;
    }
  },
);

const agencyBlurb = computed(() => {
  if (!account.value) {
    return "";
  }

  const agencyAddress = formatAddress(
    "",
    account.value.address.street,
    "",
    account.value.address.city,
    account.value.address.county,
    account.value.address.postalCode,
  );

  // To make the blurb clearer for the end user and to match summary step, display landlord c/o agency if landlord details passed
  const agencyName = landlordName.value ? `CO ${landlordName.value} ` : "";

  return [agencyName, agencyAddress, account.value.phone]
    .filter((item) => !!item)
    .join("\n");
});

const landlordBlurb = computed(() => {
  if (!props.landlord) {
    return "";
  }

  const landlordAddress = formatAddress(
    props.landlord.address.propertyName,
    props.landlord.address.street,
    props.landlord.address.locality,
    props.landlord.address.town,
    props.landlord.address.region,
    props.landlord.address.postCode,
  );

  return [landlordName.value, landlordAddress, props.landlord.number]
    .filter((item) => !!item)
    .join("\n");
});

const landlordName = computed(() => {
  if (!props.landlord) {
    return "";
  }

  return (props.landlord.firstName + " " + props.landlord.lastName).trim();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(BillToCard, {
      checked: landlordChecked.value,
      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((landlordChecked).value = $event)),
      title: "Landlord",
      blurb: landlordBlurb.value
    }, null, 8, ["checked", "blurb"]),
    _createVNode(BillToCard, {
      checked: agencyChecked.value,
      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((agencyChecked).value = $event)),
      title: "Agency",
      blurb: agencyBlurb.value
    }, null, 8, ["checked", "blurb"]),
    _createVNode(_unref(DxTooltip), {
      target: "#billTo",
      "show-event": "mouseenter",
      width: "275px",
      "hide-event": "mouseleave"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}
}

})